__turbopack_context__.v({
  "form-block": "_7vQBa_form-block",
  "form-block__fieldset": "_7vQBa_form-block__fieldset",
  "form-block__form": "_7vQBa_form-block__form",
  "form-block__submit": "_7vQBa_form-block__submit",
  "form-block__success": "_7vQBa_form-block__success",
  "form-block__wrapper": "_7vQBa_form-block__wrapper",
});
